import {createTheme, Theme} from '@mui/material';
import {mergeDeep} from '../../../lib/merge';
import {themes} from './themes.ts';

const themeCache: Record<string, Theme> = {};

export function createCachedTheme(
    themeName: keyof typeof themes,
    direction: string,
): Theme {
    const k = `${themeName}:${direction}`;
    if (themeCache[k]) {
        return themeCache[k];
    }

    return (themeCache[k] = createTheme(
        mergeDeep(
            {
                cssVariables: true,
                direction,
            },
            themes[themeName] ?? themes.default,
        ),
    ));
}
